import { Reveal } from "../lib/motion";

export default function SectionHeading({ eyebrow, title, intro, align = "left", light = false, testid }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal>
      <div data-testid={testid} className={`flex flex-col ${alignCls} max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
        {eyebrow && <p className={`eyebrow mb-4 ${light ? "text-ballk-purple" : ""}`}>{eyebrow}</p>}
        <h2 className={`font-heading font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.08] tracking-tight ${light ? "text-white" : "text-ballk-indigo"}`}>
          {title}
        </h2>
        {intro && (
          <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-white/70" : "text-ballk-steel"}`}>
            {intro}
          </p>
        )}
      </div>
    </Reveal>
  );
}
